module.exports = __webpack_public_path__ + "i18n/pl.77fd10ecf4c5a6ad3f9983aae120b916.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pl.json
// module id = 1312
// module chunks = 59